export const TOOLBAR_HTML_CONSTS = {
    changeMsg: 'Изменить',
    insertingHtmlMsg: 'Вставка HTML',
    pasteMsg: 'Вставить'
}
